module.exports = __webpack_public_path__ + "img/nature-26.380d5eee.jpg";